import DropPanel       from './components/DropPanel';
import accordion       from './components/Accordion';
import filters         from './components/Filters';
import burger          from './components/Burger';
import headerSearch    from './components/headerSearch';
import loadNext        from './utils/loadMore';
import validateRules   from './utils/validateRules';
import modalBox        from './utils/modalBox';
import CatalogCategory from './shopaholic/CatalogCategory';
import CatalogItem     from './shopaholic/CatalogItem';
import CatalogOrder    from './shopaholic/CatalogOrder';
import CookiesPanel    from './components/CookiesPanel';
import IMask           from 'imask/holder';
import 'imask/masked/dynamic';
import 'imask/masked/pattern';


function telMask(element) {
	const maskOptions = {
		mask:[
			{
				mask   :'+{7} (000) 000-00-00',
				country:'Russia'
			}
		]
	};
	const phoneMask   = IMask(element, maskOptions);
}

// Init
function init() {
	// eslint-disable-next-line no-new
	new DropPanel();
	accordion();
	filters();
	burger();
	headerSearch();
	
	// Load more
	const ajaxList = document.querySelectorAll('[data-ajax-news="wrapper"]');
	Array.from(ajaxList).forEach((list) => {
		loadNext(list, {
			list  :'[data-ajax-news="list"]',
			next  :'[data-ajax-news="next"]',
			button:'[data-ajax-news="trigger"]',
			append:'.news-card'
		});
	});
	
	// Validate
	const formValidation = document.querySelectorAll('[data-form-validation="wrapper"]');
	Array.from(formValidation).forEach((form) => {
		validateRules({
			form
		});
	});
	
	// Modal Box
	modalBox();
	
	// eslint-disable-next-line no-unused-vars
	const shopCatalog = new CatalogCategory({});
	const shopProduct = new CatalogItem({});
	const shopOrder   = new CatalogOrder({});
	
	// Phone mask
	const phoneMask = document.querySelectorAll('[data-mask="phone"]');
	Array.from(phoneMask).forEach((phoneInput) => {
		phoneInput.addEventListener('input', function (event) {
			const inputValue   = event.target.value;
			event.target.value = inputValue.replace(/[^\d+()\s-]/g, '');
		});
	});
	
	// Cookies panel
	const cookiesPanel = new CookiesPanel({
		cookies:'cookiesPanel',
		wrapper:document.querySelector('[data-cookies-panel="wrapper"]'),
		button :document.querySelector('[data-cookies-panel="close"]')
	});
	cookiesPanel.init();
	
	// Phone mask
	const telInputs = document.querySelectorAll('[data-phone-mask]');
	telInputs.forEach(element => telMask(element));
}

(function () {
	init();
}());
